export const square = {
  '.rounded': {
    'border-radius': '0px !important',
  },
  '.rounded-top': {
    'border-radius': '0px !important',
  },
};
